import { ofType } from "redux-observable";
import { mapTo } from "rxjs/operators";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
import { actionShopRequestUpdate } from "../actionShop";
export var epicShopInitialRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerInfo.Received), mapTo(actionShopRequestUpdate()));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopInitialRequest.ts
// module id = 2336
// module chunks = 3